<template>
    <main id="yagish_about">
        <section class="hero_block">
            <h2 class="h2_other renew2_wrapper">회사개요</h2>
        </section>

        <!--<section class="renew2_wrapper member">
        <h2 class="h2">members</h2>
        <div class="page_link flex sp_flex"><a class="page_link_a" href="#company">company</a>
            <a class="page_link_a" href="#access">access</a>
        </div>
        <div class="member_ceo flex">
            <div class="ceo_img deco03"><img class="ceo_photo"
                    src="https://www.yagish.jp/wp-content/themes/yagish/img/company/img_member01.png" alt="代表"></div>
            <div class="ceo_txt">
                <p class="txt_position">대표이사</p>
                <p class="txt_name">김 상 집</p>
                <p class="ceo_txt_outline">도쿄공업대학 사회이공학 연구과에서 박사학위 취득 후, NHN Japan 주식회사(현 LINE 주식회사), 주식회사 넥스트(현 주식회사
                    LIFULL)에서 신규사업부에 종사하였고 2008년부터 주식회사 링케이지아를 설립하여 대표이사 취임. 싱가포르, 일본, 한국을 중심으로 한 아시아 사업전개를 진행한 후, 주식회사
                    미로크정보서비스의 신규사업 및 투자담당 책임자를 맡으며 도쿄대학의 첨단과학 기술연구센터의 객원 연구원을 겸임. 2021년 9월 주식회사 Yagish를 설립하여 대표이사 사장 취임.
                </p>

            </div>
        </div>
        <div class="member_list">
            <ul class="flex sp_flex" style="justify-content: space-around;">
                <li class="member_item deco03"><img class="member_img"
                        src="https://www.yagish.jp/wp-content/themes/yagish/img/company/img_member02.png" alt="金 起満">
                    <p class="txt_position">이사 겸 CTO</p>
                    <p class="txt_name">김 기만</p>
                </li>
                <li class="member_item deco03"><img class="member_img"
                        src="https://www.yagish.jp/wp-content/themes/yagish/img/company/img_member03.png" alt="島 伸明">
                    <p class="txt_position">이사 겸 CMO</p>
                    <p class="txt_name">Shima<br>Nobuaki</p>
                </li>
                <li class="member_item deco03"><img class="member_img"
                        src="https://www.yagish.jp/wp-content/themes/yagish/img/company/img_member07.png" alt="三谷 卓也">
                    <p class="txt_position">이사 겸 CSO</p>
                    <p class="txt_name">Mitani<br> Takuya</p>
                </li>
                <li class="member_item deco03"><img class="member_img"
                        src="https://www.yagish.jp/wp-content/themes/yagish/img/company/img_member06.png" alt="中嶋 克久">
                    <p class="txt_position">감사</p>
                    <p class="txt_name">Nakajima<br> Katsuhisa</p>

                </li>
            </ul>
        </div>
    </section>-->

        <section id="company" class="company">
            <div class="company_table renew2_wrapper shadow-gray">
                <div class="flex company_row">
                    <p class="td">상호</p>
                    <p class="td">주식회사 야기슈</p>
                </div>
                <div class="flex company_row">
                    <p class="td">설립</p>
                    <p class="td">2021년9월1일</p>
                </div>
                <div class="flex company_row">
                    <p class="td">본점소재지</p>
                    <p class="td">2-3-12 Ebisu Nishi, Shibuya-ku, Tokyo</p>
                </div>
                <div class="flex company_row">
                    <p class="td">운영회사URL</p>
                    <p class="td"><a href="https://www.yagish.jp/" target="_blank">https://www.yagish.jp/</a></p>
                </div>
                <div class="flex company_row">
                    <p class="td">경영진</p>
                    <p class="td">대표이사 김 상집<br>
                        이사 겸 CTO 김 기만<br>
                        이사 겸 CMO Shima Nobuaki<br>
                        이사 겸 CSO Mitani Takuya<br>
                        감사 Nakajima Katsuhisa
                    </p>
                </div>
                <div class="flex company_row">
                    <p class="td">자본금</p>
                    <p class="td">9,500만엔(자본준비금 포함)</p>
                </div>
                <div class="flex company_row">
                    <p class="td">사업내용</p>
                    <ul class="td">
                        <li class="list">이력서/경력기술서 작성 서비스 제공(일본 최대급)</li>
                        <li class="list">다이렉트 리쿠루딩 서비스 운영</li>
                    </ul>
                </div>
                <div class="flex company_row">
                    <p class="td">거래 실적</p>
                    <ul class="td">
                        <li class="list">Kakaku.com Co., Ltd.</li>
                        <li class="list">Mynavi Co., Ltd.</li>
                        <li class="list">Mynavi Middle Senior Co., Ltd.</li>
                        <li class="list">Medley Co., Ltd.</li>
                        <li class="list">Trite Co., Ltd.</li>
                        <li class="list">Quick Co., Ltd.</li>
                        <li class="list">SB Human Capital Co., Ltd.</li>
                        <li class="list">ROXX Co., Ltd.</li>
                        <li class="list">Jake Co., Ltd.</li>
                        <li class="list">System Shared Co., Ltd.</li>
                    </ul>
                </div>
                <div class="flex company_row">
                    <p class="td">야기슈 공식 파트너</p>
                    <ul class="td">
                        <li class="list">Osaka Sangyo University</li>
                        <li class="list">Kansai Gaidai University</li>
                        <li class="list">Baika Women's University</li>
                    </ul>
                </div>
            </div>
        </section>

        <!--<section id="access" class="access renew2_wrapper">
        <h2 class="h2">access</h2>
        <p class="address">3F, 2-3-12 Ebisu Nishi, Shibuya-ku, Tokyo</p>
        <p class="address_time">도보5분from Ebisu Station </p>
        <div>
            <iframe style="border: 0;"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.110055562067!2d139.70589520916369!3d35.64966002531859!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b439550071d%3A0x3f2688de0bff1b2f!2z44CSMTUwLTAwMjEg5p2x5Lqs6YO95riL6LC35Yy65oG15q-U5a-_6KW_77yS5LiB55uu77yT4oiS77yR77ySIOaBteavlOWvv-OCquODvOOCr-ODk-ODrOODg-OCuOODk-ODqw!5e0!3m2!1sja!2sjp!4v1674738143799!5m2!1sja!2sjp"
                allowfullscreen="allowfullscreen">
            </iframe>
        </div>
    </section>-->
    </main>
</template>
<style lang="css" src="@/assets/css/renew_info.css"></style>
<style lang="scss" scoped>
#yagish_about .hero_block {
    padding: 40px;
    background: #0F9934;
    justify-content: center;
}

#yagish_about .h2_other {
    color: #fff;
    font-size: 2rem;
}

#yagish_about .company_table {
    background: #fff;
    padding: 80px;
}

#yagish_about .company_row {
    border-bottom: 1px solid #DFDFDF;
}

#yagish_about .company_row:last-child {
    border: none;
}

#yagish_about .td {
    padding: 25px;
    padding-left: 30px;
}

#yagish_about .td:first-child {
    width: 25%;
    font-weight: bold;
}

@media screen and (max-width: 640px) {
    #yagish_about .company_table {
        padding: 20px;
    }

    #yagish_about .td {
        width: 100%;
        padding-left: 25px;
    }

    #yagish_about .td:first-child {
        width: 100%;
        padding-bottom: 0;
    }
}
</style>
<script>
export default {

    created: function () {
    }
}
</script>
